import { isActionWhitelisted } from 'layout/widgets/adaChat/actionPermissions'
import { loadBatteryDesignAssistantResult } from 'layout/widgets/adaChat/utils/loadBatteryDesignAssistantResult'
import {
  isInDesignTab,
  validateActionRequirementsOrThrow,
} from 'layout/widgets/adaChat/utils/validateActionRequirements'
import { LiveFunctionCall } from '../GeminiLiveAPI/lib/multimodal-live-types'

interface LoadBatteryDesignAssistantResultArgs {
  batterySetIndex: number
  confirmed?: boolean
}

export const TOOL_NAME = 'load_battery_design_assistant_result'

export async function LoadBatteryDesignAssistantResultToolCall(
  functionCall: LiveFunctionCall,
  history: any,
  orgId: number | undefined
) {
  const args = functionCall.args as LoadBatteryDesignAssistantResultArgs

  console.log('[Voice] LoadBatteryDesignAssistantResultToolCall', args)

  const pathname = window.location.pathname
  validateActionRequirementsOrThrow('loadBatteryDesignAssistantResult', pathname)

  // Extract project ID from pathname
  const { projectId } = isInDesignTab(pathname)

  if (!projectId) {
    throw new Error('Project ID is required to load battery recommendations')
  }

  // Check if this action requires confirmation (it doesn't, but check anyway)
  const isWhitelisted = isActionWhitelisted('loadBatteryDesignAssistantResult')

  // Load the battery recommendation
  try {
    await loadBatteryDesignAssistantResult(args.batterySetIndex)

    // Update the toolExecutionState to 'completed' if we can find the message
    if (window.reduxStore && projectId) {
      const state = window.reduxStore.getState()
      const messages = state?.chatDrawer?.messages || []

      let targetMessageIndex = -1
      for (let i = messages.length - 1; i >= 0; i--) {
        if (
          messages[i].direction === 'receive' &&
          messages[i].toolExecutionState &&
          messages[i].toolExecutionState.toolType === 'batteryDesignAssistant'
        ) {
          targetMessageIndex = i
          break
        }
      }

      if (targetMessageIndex >= 0) {
        const { chatDrawerActions } = await import('ducks/chatDrawer')
        window.reduxStore.dispatch(
          chatDrawerActions.updateToolExecutionState(targetMessageIndex, {
            toolType: 'batteryDesignAssistant',
            status: 'completed',
            description: 'Battery Added', // Translation key - will be translated in BaseToolProgressItem
            projectId: projectId,
          })
        )
      }
    }

    return {
      success: true,
      message: `Battery recommendation ${args.batterySetIndex + 1} loaded successfully`,
    }
  } catch (error: any) {
    console.error('[Voice] Load battery design assistant result error:', error)

    // Update the toolExecutionState to 'error' if we can find the message
    if (window.reduxStore && projectId) {
      const state = window.reduxStore.getState()
      const messages = state?.chatDrawer?.messages || []

      let targetMessageIndex = -1
      for (let i = messages.length - 1; i >= 0; i--) {
        if (
          messages[i].direction === 'receive' &&
          messages[i].toolExecutionState &&
          messages[i].toolExecutionState.toolType === 'batteryDesignAssistant'
        ) {
          targetMessageIndex = i
          break
        }
      }

      if (targetMessageIndex >= 0) {
        const { chatDrawerActions } = await import('ducks/chatDrawer')
        window.reduxStore.dispatch(
          chatDrawerActions.updateToolExecutionState(targetMessageIndex, {
            toolType: 'batteryDesignAssistant',
            status: 'error',
            projectId: projectId,
            description: error?.message || 'Failed to load battery recommendations',
            error: {
              message: error?.message || 'Failed to load battery recommendations',
            },
          })
        )
      }
    }

    throw error
  }
}
